module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalfiles-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_files_index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAppraisalFile($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisalfile_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalfile_table.filter),
        expression: "appraisalfile_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisalfile_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalfile_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm._.orderBy(_vm.appraisalfiles_to_array(_vm.appraisalfiles), ['date_modified'], ['desc']),
        "page-size": 50,
        "filter": _vm.appraisalfile_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "50",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalfile_table.striped,
              "editable": _vm.appraisalfile_table.editable,
              "line-numbers": _vm.appraisalfile_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "number",
              fn: function(cell) {
                return [_c('span', {
                  staticClass: "navspan",
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      _vm.goToFile(cell.row['id'])
                    }
                  }
                }, [_vm._v(_vm._s(cell.row['number']))])]
              }
            }, {
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisalFile(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalFile(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.appraisalfile_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca542e22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/files/AppraisalFilesIndex.vue
// module id = 2186
// module chunks = 0